import React, { PropsWithChildren, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer, toast, ToastOptions } from 'react-toastify';
import { SystemMessage } from '../../libs/system/SystemMessage';
import {
  SystemMessageContext,
  useSystemMessageContext,
} from './SystemMessageContext';
import 'react-toastify/dist/ReactToastify.css';
import { LoadingProvider } from './LoadingContext';
import {
  TaskCollapsedContext,
  useTaskCollapsedContext,
} from './TaskCollapsedContext';
import { FileSearchContext, useFileSearchContext } from './FileSearchContext';
import {AuthProvider} from "./AuthContext";

export const AppContextProvider: React.FC = (props: PropsWithChildren<any>) => {
  const fileSearchContext = useFileSearchContext();
  const taskCollapsedContext = useTaskCollapsedContext();
  const systemMessageContext = useSystemMessageContext();
  const [messages, setMessages] = React.useState<SystemMessage[]>(
    systemMessageContext.messages
  );
  const toastOptions = (id: string): ToastOptions => ({
    toastId: id,
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  useEffect(() => {
    setMessages(systemMessageContext.messages);
    // eslint-disable-next-line
  }, [systemMessageContext.messages.length]);

  const handleClose = async (id: string) => {
    await systemMessageContext.removeMessage(id);
  };

  useEffect(() => {
    messages.forEach(async (m) => {
      switch (m.type) {
        case 'danger':
          toast.error(m.body, toastOptions(m.id));
          break;
        case 'success':
          toast.success(m.body, toastOptions(m.id));
          break;
        case 'info':
          toast.info(m.body, toastOptions(m.id));
          break;
        case 'warn':
          toast.warn(m.body, toastOptions(m.id));
          break;
        default:
          toast.error('エラーが発生しました。', toastOptions(m.id));
      }
      await handleClose(m.id);
    });
    // eslint-disable-next-line
  }, [messages.length]);

  const { children } = props;

  return (
    <LoadingProvider>
      <SystemMessageContext.Provider value={systemMessageContext}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
        <TaskCollapsedContext.Provider value={taskCollapsedContext}>
          <FileSearchContext.Provider value={fileSearchContext}>
            <Router>
              <AuthProvider>
                {children}
              </AuthProvider>
            </Router>
          </FileSearchContext.Provider>
        </TaskCollapsedContext.Provider>
      </SystemMessageContext.Provider>
    </LoadingProvider>
  );
};
